import { LdsLoadingSpinner } from "@elilillyco/ux-lds-react";
import "./../../assets/scss/shared/loading.css";

const CLoader = ({ size }) => {
  return <LdsLoadingSpinner className="p-loading-spinner" size={size} />;
};

export default CLoader;
